export default "__VITE_ASSET__bf8UQB8N__"